/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
// import Fancybox from './site/fancybox';
import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
// import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
// import LoadMoreBlog from './site/loadMoreBlog';
import stickyHeader from './site/stickyHeader';
import aos from './site/aos';
import serviceCards from './site/serviceCards';
import accordion from './site/accordion';
import tabs from './site/tabs';
import equalHeight from './site/equalHeight';
import counter from './site/counter';
import footer from './site/footer';
import infoList from './site/infoList';
import BlogPostsModifier from './site/BlogPostsModifier';
import pageLoader from './site/pageLoader';
import accordionBig from './site/accordionBig';
import stepsAnimation from './site/stepsAnimation';
import accordionEvents from './site/accordionEvents';
import EventsList from './site/eventsList';
import JobsList from './site/jobsList';
import uploadFile from './site/uploadFile';
import datePicker from './site/datePicker';
import accordionPosition from './site/accordionDisciplines';
import formPopup from './site/formPopup';
import jobapplicationform from './site/jobapplicationform';
import contactFormSelect from './site/contactFormSelect';
import languageSwitcher from './site/languageSwitcher';

/**
 * Init site scripts
 */
jQuery(function() {
	SkipLinkFocusFix.init();
	EventsList.init();
	JobsList.init();
	Styleguide.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	// Fancybox.init();
	Select2.init();
	FormHelpers.init();
	// PerfectScroll.init();
	LazyLoading.init();
	// LoadMoreBlog.init();
	stickyHeader.init();
	aos.init();
	serviceCards.init();
	accordion.init();
	tabs.init();
	equalHeight.init();
	counter.init();
	footer.init();
	infoList.init();
	BlogPostsModifier.init();
	pageLoader.init();
	accordionBig.init();
	stepsAnimation.init();
	accordionEvents.init();
	uploadFile.init();
	datePicker.init();
	accordionPosition.init();
	formPopup.init();
	jobapplicationform.init();
	contactFormSelect.init();
	languageSwitcher.init();
});
